import React, { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import 'util/core/tool/capitalise'
import './index.css'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import moment from 'moment'
import initI18n from './i18n'
import i18n from 'i18next'
import { ThemeProvider } from 'styled-components'
import { theme } from './theme'
import { type ConfigInterface } from 'util/core/config/config.interface'
import { appConfig } from 'util/core/config/app-config.instance'
import { authService } from 'util/core/service/auth.service'
import TagManager from 'react-gtm-module'
import { UserProvider } from 'util/core/service/user-provider'
import { pdfjs } from 'react-pdf'

void (async () => {
  const env = process.env.REACT_APP_ENV ?? 'dev'
  const envModule = await import(`./environments/environment.${env}`)
  const environment = envModule.environment as ConfigInterface

  const config: ConfigInterface = {
    production: environment.production,
    SEARCH_API: environment.SEARCH_API,
    USERS_API: environment.USERS_API,
    ECONTRACTING_API: environment.ECONTRACTING_API,
    TRANSLATIONS_URL: environment.TRANSLATIONS_URL,
    PROZORRO: environment.PROZORRO,
    AUCTIONS_PROZORRO: environment.AUCTIONS_PROZORRO,
    PROZORRO_API_LINK: environment.PROZORRO_API_LINK,
    OLD_DZO: environment.OLD_DZO,
    FILES: environment.FILES,
    NEWS: environment.NEWS,
    CALLME: environment.CALLME,
    MESSAGES: environment.MESSAGES,
    defaultLanguage: environment.defaultLanguage,
    languages: environment.languages,
    ENABLE_GOOGLE_TAG_MANAGER: environment.ENABLE_GOOGLE_TAG_MANAGER,
    GOOGLE_TAG_ID: environment.GOOGLE_TAG_ID,
    ENABLE_CABINET: environment.ENABLE_CABINET,
    ENABLE_TEST_MODE: environment.ENABLE_TEST_MODE,
    ENABLE_LOG_PRODUCT_CHARACTERISTICS_MISMATCH: environment.ENABLE_LOG_PRODUCT_CHARACTERISTICS_MISMATCH,
    ENABLE_EDRPOU_VALIDATION: environment.ENABLE_EDRPOU_VALIDATION,
    ENABLE_E_CONTRACTING: environment.ENABLE_E_CONTRACTING
  }

  appConfig.load(config)

  await initI18n()

  await authService.init()

  moment.locale(i18n.language)

  const basename = (i18n.language === environment.defaultLanguage) ? '' : `/${i18n.language}`

  const app = <Suspense fallback={'...'}>
      <BrowserRouter basename={basename}>
        <ThemeProvider theme={theme}>
          <UserProvider>
            <App />
          </UserProvider>
        </ThemeProvider>
      </BrowserRouter>
  </Suspense>

  if (appConfig.get('ENABLE_GOOGLE_TAG_MANAGER')) {
    TagManager.initialize({ gtmId: appConfig.get('GOOGLE_TAG_ID') })
  }

  pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url
  ).toString()

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  )
  root.render(app)
  // ReactDOM.render(app, document.getElementById('root'));
})()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
